<template>
	<section class="section-app">
		<section-head
			title="Select A Deck"
			description="Take a look and familiarize yourself with the ship and cabin layout."
		/>

		<div class="deck" :class="isZoomed ? 'zoomed':''" v-if="availableDecks.length">
			<div class="deck__head"
				data-simplebar data-simplebar-auto-hide="true"
			>
				<div class="deck__nav">
					<div class="deck__link"
						v-for="deck in availableDecks"
						:class="`${active === deck.id ? 'is-active':''} ${deck.available ? 'available' : 'sold-out'} ${deck.no_cabs ? '' : 'no-cabins'}`"
						@click="active = deck.id"
					>
						<button
							:value="deck.id"
						>
							{{ deck.title }}
						</button>
					</div>
				</div>
			</div><!-- /.deck__head -->

			<div class="deck__content">
				<div class="deck__body"
					data-simplebar data-simplebar-auto-hide="true"
					v-for="deck in decks"
					v-if="active === deck.id"
				>
					<div class="deck__image">
						<div class="deck__controls">
							<button
								class="deck-btn"
								@click="handleNextClick"
							>
								Zoom {{ isZoomed ? 'Out -':'In +'}}
							</button>

							<a class="deck-btn"
								v-if="deck.pdf"
								:href="deck.pdf"
								target="_blank"
							>
								View PDF
							</a>
						</div>
						<img :src="`${deck.image}`" alt="">
					</div>
				</div>
			</div>
		</div>

		<h2 v-else>
			There are currently no available rooms for passengers specified.
		</h2>

		<div class="section__foot">
			<button
				class="btn btn-gray"
				@click="handlePrevClick"
			>
				Back
			</button>

			<button
				class="btn btn-blue"
				v-if="availableDecks.length"
				@click="handleNextClick"
			>
				Select Deck
			</button>
		</div>
	</section>
</template>

<script>
/**
 * External Dependencies
 */
import 'simplebar';
import 'simplebar/dist/simplebar.css';
import { orderBy } from 'lodash';

/**
 * Internal Dependencies
 */
import SectionHead from '../components/SectionHead.vue';
import { mapGetters, mapActions } from 'vuex';

export default {
	/**
	 * Component Name.
	 *
	 * @type {String}
	 */
	name: 'cruise-cruise',

	data(){
		return{
			isZoomed: false,
			active: null
		}
	},

	components: {
		SectionHead,
	},

	computed: {
		/**
		 * Map Store's Getters
		 */
		...mapGetters({
			'decks': 'getDecks',
			'product': 'getProduct',
		}),

		availableDecks(){
			this.decks.map(deck => {
				deck.available = deck.cabins.length ? true : false;

				return deck;
			})

			return _.orderBy(this.decks, ['number'], ['desc']);
		}
	},

	methods:{
		/**
		 * Map Store's Actions
		 */
		...mapActions([
			'setProductEntry',
			'resetProductEntry',
			'completeStep',
			'resetSteps',
		]),

		handlePrevClick() {
			this.$router.push({name:'cruise.passengers'})
		},

		handleNextClick() {
			if (this.product.deck !== this.active) {
				this.resetProductEntry({
					entry: ['cabin'],
				})

				this.resetSteps({
					steps: ['cabin'],
				})
			}

			this.setProductEntry({
				entry: 'deck',
				fields: this.active
			})
			this.completeStep({
				step: 'deck'
			});
			this.$router.push({name:'cruise.cabin'})
		},

		toggleZoom(){
			this.isZoomed = !this.isZoomed
		},
	},

	mounted(){
		if (this.product.deck !== null) {
			this.active = this.product.deck
		} else {
			this.active = this.decks[0].id
		}
	}
}
</script>

<style>
	.simplebar-track { width: 10px; z-index: 5; }
	.simplebar-scrollbar { width: 10px; right: 0; opacity: 0; }
	.simplebar-scrollbar.visible { opacity: 1; }
	.simplebar-scrollbar:before { border-radius: 0; background: #4a4a4a;  }

	.deck { display: flex; justify-content: space-between;}
	.deck .deck__image { height: 650px; text-align: center; }
	.deck .deck__image img { height: 100%; width: auto;  }

	.deck.zoomed .deck__image { height: auto;  }
	.deck.zoomed .deck__image img { width: 100%; height: auto; }

	.deck .deck__controls { position: absolute; top: 20px; right: 20px; width: 110px; }
	.deck .deck__controls .deck-btn { display: block; width: 100%; appearance: none; border-radius: 16px; border: 1px solid #9b9b9b; color: #9b9b9b; font-weight: 700; box-shadow: 0 2px 4px rgba(0, 0, 0, .5); background: #fff; margin-bottom: 20px; height: 33px; line-height: 33px; text-align: center; white-space: nowrap; transition: border .4s, color .4s; }
	.deck .deck__controls .deck-btn:hover { text-decoration: none;  border-color: #13373d; color: #13373d;  }


	.deck .deck__link { position: relative; z-index: 1; font-size: 16px; text-align: center; width: 100%; font-weight: 700; color: #9b9b9b; }
	.deck .deck__link button { position: relative; width: 100%; appearance: none; border: 0; border-radius: 0; background: #fff;  border-left: 10px solid #89d2bf; text-decoration: none; display: block; color: inherit; padding: 15px 10px; transition: color .4s, border .4s, background .4s; overflow: hidden; white-space: nowrap; text-overflow: ellipsis; font-weight: 700; }
	.deck .deck__link button:before { content: ''; position: absolute; bottom: 0; left: 0; bottom: 0; right: 0; height: 1px; background: #d3d3d3; transition: background .4s; }
	.deck .deck__link.is-active button { color: #fff; background: #13373d; border-left-color: #13373d; }
	.deck .deck__link.is-active button:before {  background: #13373d;  }
	.deck .deck__link:not(.is-active):hover button { background: #a27c2c;  border-left-color: #a27c2c; color: #fff;}
	.deck .deck__link:not(.is-active):hover button:before { background: #a27c2c; }

	.deck .deck__link.sold-out { cursor: pointer; }
	.deck .deck__link.sold-out button { background: #fff; border-left: 10px solid #89d2bf; pointer-events: none; overflow: hidden; }
	.deck .deck__link.sold-out button:before { background: rgba(0, 0, 0,.6); width: 100%; height: 100%; }
	.deck .deck__link.sold-out button:after { content: 'Sold Out'; width: 100%; height: 100%; transform: rotate(-16deg);  position: absolute; top: 0; left: 0; display: flex; align-items: center; justify-content: center; color: #fff; font-weight: 700; z-index: 2; }
	.deck .deck__link.sold-out.no-cabins button:after {display:none}
	.deck .deck__link.sold-out.no-cabins button:before { background: rgba(0,0,0,.04); border-bottom: 1px solid #ccc;}
	.deck .deck__link.sold-out:hover button {  }
	.deck .deck__link.sold-out:hover button:before  {  }
	.deck .deck__link.sold-out.is-active button { color: #fff; background: #13373d; border-left-color: #13373d; }

	.deck .deck__head {  width: 250px; min-height: 650px; background: #fff; box-shadow: 0 0 4px rgba(0, 0, 0, .5); position: relative;  }
	.deck .deck__nav { list-style: none;}
	.deck .deck__nav:before { content: ''; top: 0; left: 0; width: 10px; bottom: 0; position: absolute; background: #89d2bf; }

	.deck .deck__body { height: 650px; }
	.deck .deck__content  { background: #fff; width: calc(100% - 270px); margin-left: 20px; box-shadow: 0 0 4px rgba(0, 0, 0, .5);}

	@media(max-width: 767px){
		.deck { flex-wrap: wrap; }
		.deck .deck__content { margin-left: 0; width: 100%;  }
		.deck .deck__head { width: 100%; min-height: 1px; margin-bottom: 20px; }
		.deck .deck__body { height: 400px; }
		.deck .deck__controls { top: 0; left: 0; width: 100%; padding: 10px; display: flex; justify-content: space-between; }
		.deck .deck__controls .deck-btn { width: 110px;  margin-bottom: 10px; }
	}
</style>



// WEBPACK FOOTER //
// src/pages/CruiseDeck.vue